/**
 * Chrome rejects HTMLAudioElement.play() with AbortError when pause() runs
 * before play() resolves. Twilio Voice SDK does this on fast disconnect
 * (outgoing ringtone + remote audio) and does not always catch the promise.
 */

export function isInterruptedPlayRejection(reason) {
  if (reason == null) return false;
  const name = reason.name || "";
  const message =
    typeof reason === "string" ? reason : String(reason.message || "");
  return (
    name === "AbortError" ||
    message.includes("play() request was interrupted")
  );
}

/**
 * @param {PromiseRejectionEvent} event
 * @returns {boolean} true if the rejection was swallowed
 */
export function suppressInterruptedPlayRejection(event) {
  if (!isInterruptedPlayRejection(event?.reason)) return false;
  event.preventDefault();
  event.stopImmediatePropagation();
  return true;
}
